/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ErrorResponse, LegalForm } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class LegalFormApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns, for every country, the legal forms that are selectable for that country
   *
   * @tags legal-form-api
   * @name GetLegalFormsByCountry
   * @summary Get legal forms by country
   * @request GET:/api/legal-forms/by-country
   * @secure
   */
  getLegalFormsByCountry = (params: RequestParams = {}) =>
    this.request<Record<string, LegalForm[]>, ErrorResponse>({
      path: `/api/legal-forms/by-country`,
      method: "GET",
      secure: true,
      ...params,
    });
}
